import { mapGetters, mapActions } from "vuex";
import selectAddr from "@/components/selectAddr";
import selectRecAddr from "@/components/selectRecAddr";
import moment from "moment";
import _ from "lodash";
import getMvcUrl from "../../utils/mvcUrlUtil.js";
import contractMsg from '../autho/contractMsg';
import {fetchGet,fetchPost} from '@/api/http.js';
import getCheckPhone from '@/common/js/checkPhone.js';

const stopReadOnly = {
  addrDetail: false,
  orderPlacerName: false,
  orderPlacerPhone: false,
  planArriveTm: false,
  planSendtm: false,
  jobType: false,
};

export default {
  components: {
    selectAddr,
    selectRecAddr,
    contractMsg
  },
  data() {
    const checkSelect = (rule, value, callback) => {
      setTimeout(()=>{
        if(!value || this.selectItem.length === 0){
          return callback(new Error("请输入承运公司"),)
        }
        return callback()
      },600)
    };
    // 手机号校验
    const checkPhone = getCheckPhone();
    // 手机号校验
    const checkStopPhone = getCheckPhone(false);

    return {
      inputErrorMsg: '',
      inputFlag: false,
      driverInfoRemarks: '', // 司机信息备注
      disableExpectedPriceByServiceScene: false, // 根据serviceScene控制期望运费是否禁用
      sx: {
        vehicleTypeName: '',
        vehicleLength: '',
      },
      bidDays: '',
      bidHours: '',
      bidMinutes: '',
      recAddressList: [],
      thirdPlaceOrder: false,
      effectLoadCapacity: '',
      systemCode: null,
      waitHandelOrderId: null,
      invokeSource: null,
      stopsDisabledSwitch: false,
      readOnly: {
        cargoInfo: false,
        cargoVolume: false,
        cargoWeight: false,
        quantity: false,
        startAddrDetail: false,
        startOrderPlacerName: false,
        startOrderPlacerPhone: false,
        startPlanArriveTm: false,
        startPlanSendtm: false,
        endAddrDetail: false,
        endOrderPlacerName: false,
        endOrderPlacerPhone: false,
        endPlanArriveTm: false,
        totalLineDistance: false,
        outerOrderId: false,
        comment: false,
        vehicleType: false,
        vehicleLength: false,
        needReceipt: false,
        receiptAddress: false,
        receiptName: false,
        receiptPhone: false,
        hideAddStopBtn: false,
        fromApi: false
      },
      stopsReadOnly: [],
      updateSuccRes: {
        orderId: null,
        version: null
      },
      processReasons: [
        { label: '客户需求变更', value: 'R1' },
        { label: '信息填写错误', value: 'R2' },
        { label: '用车时间计划变更', value: 'R3' },
        { label: '增加押车费', value: 'R4' },
        { label: '增加装卸费', value: 'R5' },
        { label: '车辆故障', value: 'R6' },
        { label: '其它', value: 'R0' },
      ],
      isAlter: false,
      uploadUsualLineLoading: false,
      filterAddress: '',
      filename: '',
      changed: false,
      uploadBtn: true,
      activeName: 'single',
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24 || time.getTime() > Date.now() + 3600 * 1000 * 24 * 60
        }
      },
      isOrdering: false,
      isOrderAltering: false,
      disablePlaceOrder: false, // 禁用发布按钮
      state: 1,
      show: {
        RobOrder: false,
        SendOrder: false,
        BidOrder: false,
      },
      addAddressVisible: false,
      driverTag: '',
      newAddress: {
        province: '',
        district: '',
        addrDetail: '',
        cityName: '',
        cityCode: '',
        coordinate: '',
        contacts: '',
        phone: '',
        shortName: '',
        rules: {
          contacts: [{ required: true, message: "请输入联系人", trigger: "blur" }],
          shortName: [{ required: true, message: "请输入地址简称", trigger: "blur" }],
          phone: [
            { required: true, message: "请选择联系方式", trigger: "blur" },
            { validator:checkPhone, message: "请输入正确的联系方式", trigger: "blur" }
          ],
          addrDetail: [{ required: true, message: "请选择地址", trigger: "change" }],
        }
      },
      addressList: [],
      querystring: '',
      orderType: "single",
      activeTabName: 'first',
      mapVisible: false,
      currentTm: moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
      totalFee: '',
      SFMap: window.SFMap,
      map: {
        markerTpl: null,
        mapIns: null,
        vectorLayer: null,
        markersList: [],
        currVo: null,
        poiset: [],
        inputCityName: '深圳市',
        keyWord: '',
        province: '',
        district: '',
        cityCode: '',
        addrDetail: '',
        cityName: '',
        coordinateLon: null,
        coordinateLat: null,
      },
      form: {
        processReason: '',
        processReasonComment: '',
        isSaveFrequentlyLine: false,
        def: {
          days: 0,
          hours: 0,
          minutes: 0
        },
        "expectedPrice": '',
        "outerOrderId": '',
        "quantity": '',
        "cargoComment": '',
        "uuid": '',
        "totalPrice": '',
        "biddenStartTm": '',
        "biddenEndTm": '',
        "assignDriverParam": {
          "userId": '',
          "userName": '',
          "driverId": null,
          "driverName": "",
          "driverPhone": "",
          "vehicleSerial": "",
          list: [],
          vehicleId: '',
          carList: [],
        },
        "assignCarrierParam": {
          "userId": '',
          "userName": '',
          "carrierId": null,
          "carrierName": "",
          "type": 1,
        },
        "carrierAssignFlag": null,
        "cargoInfo": "1700",
        "cargoVolume": '',
        "cargoWeight": '',
        "carrierType": 1,
        "comment": "",
        addedComments: [],
        "dataOwner": null,
        projectCode: '',
        "needReceipt": 2,
        "reachTm": '',
        "receiptAddress": "",
        "receiptName": "",
        "receiptPhone": "",
        "receiptType": 1,
        start: {
          "addrDetail": "",
          "cityCode": "",
          "cityName": "",
          "coordinate": "",
          "jobType": 1,
          "orderPlacerName": "",
          "orderPlacerPhone": "",
          "planArriveTm": '',
          "planSendtm": '',
          "sortNum": 1
        },
        stops: [],
        end: {
          "addrDetail": "",
          "cityCode": "",
          "cityName": "",
          "coordinate": "",
          "jobType": 2,
          "lineDistance": 0,
          "orderPlacerName": "",
          "orderPlacerPhone": "",
          "planArriveTm": '',
          "planSendtm": '',
          "sortNum": 2
        },
        "saasPassZoneVOs": [],
        "userId": '',
        "tenantId": '',
        "totalLineDistance": '',
        "totalRunTm": 0,
        "vehicleLength": null,
        "vehicleType": "",
        "mode": 1,
        "isLongOrder": false,
        tradeClient: ''
      },
      // B（B端承运商），C（C端司机）、BC（B端承运商+C端司机）
      isSx: false,
      projectCodeOptions: [],
      checkStopPhone,
      // rules: {
      //   processReason: [{ required: true, message: "请选择修改原因", trigger: "change" }],

      //   'start.addrDetail': [{ required: true, message: "请输入发货地址", trigger: "change" }],
      //   'start.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
      //   'start.orderPlacerPhone': [{ required: true, trigger: "blur", validator: checkPhone }],
      //   'start.planArriveTm': [{ required: true, message: "请输入到场时间", trigger: "change" }],
      //   'start.planSendtm': [{ required: true, message: "请输入计划发车时间", trigger: "change" }],

      //   'end.addrDetail': [{ required: true, message: "请输入收货地址", trigger: "change" }],
      //   'end.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
      //   'end.orderPlacerPhone': [{ required: true, trigger: "blur", validator: checkPhone }],
      //   'end.planArriveTm': [{ required: true, message: "请选择计划到达时间", trigger: "change" }],

      //   cargoInfo: [{ required: true, message: "请选择货物信息", trigger: "change" }],
      //   cargoWeight: [{ required: true, message: "请输入货物重量", trigger: "change" }],
      //   cargoVolume: [{ required: true, message: "请输入货物体积", trigger: "change" }],
      //   dataOwner: [{ required: true, message: "请选择订单归属", trigger: "change" }],

      //   receiptAddress: [{ required: true, message: "请输入签收地址", trigger: "change" }],
      //   receiptName: [{ required: true, message: "请输入联系人姓名", trigger: "change" }],
      //   receiptPhone: [{ required: true, trigger: "blur", validator: checkPhone }],

      //   'carrierType': [{ required: true, message: "请选择承运对象", trigger: "change" }],
      //   'assignDriverParam.driverName': [{ required: true, message: "请输入承运司机", trigger: "change" }],
      //   'assignDriverParam.vehicleId': [{ required: true, message: "请选择承运车辆", trigger: "change" }],
      //   'assignCarrierParam.carrierName': [{ required: true,  trigger: "change",validator:checkSelect }],

      //   expectedPrice: [{ required: true, message: "请输入期望运费", trigger: "change" }],
      //   biddenStartTm: [{ required: true, message: "请输入竞价开始时间", trigger: "change" }],
      //   biddenEndTm: [{ required: true, message: "请输入竞价结束时间", trigger: "change" }],
      //   tradeClient: [{ required: true, message: "请选择交易方式", trigger: "change" }],
      //   quantity: [
      //     {
      //       trigger: "change",
      //       required: false,
      //       validator: (rule, value, callback) => {
      //         if (value !== "") {
      //           if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false) {
      //             callback(new Error("请填写大于0的数字"));
      //           } else {
      //             if (Number(value) == 0) {
      //               callback(new Error("请填写大于0的数字"));
      //             } else {
      //               callback();
      //             }
      //           }
      //         } else {
      //           callback();
      //         }
      //       }
      //     }
      //   ]
      // },
      prev: {
        "cargoInfos": [],
        "dataOwner": [],
        modes: '',
        "ownerName": "",
        "placerNames": [],
        comments: ["三不超", "需雨布", "带尾板", "无禁区", "全程高速"],
        vehicle: {
          Maps: null,
          typeMapLens: [],
          lens: [],
          "vehicleLength": null,
          "vehicleType": "",
          "plVehicleCode": ""
        },
      },
      stopNoDisAndTm: false,
      stopOrderManageId: '',
      stopOrderId: '',
      selectItem:[],
      signDialogVisible:false,
      contractDialogVisible:false,
      IScontract:"",
      ISsme:"",
      notSigned:false,
      contractRow:{id:""},
      pageType:2,//1.合同列表 2.发临时单
      cysjClikFlag: false,
      cygsClickFlag: false,
      isTempOrder: false,
      driverLoading: false,
      driverOptions: [],
      carrierLoading: false,
      carrierOptions: [],
      approvalMsg: '',
    };
  },
  watch: {
    'prev.vehicle.vehicleType': function (val) {
      this.prev.vehicle.vehicleLength = null
      this.prev.vehicle.typeMapLens.forEach(item => {
        if (item.plVehicleType == val) {
          this.prev.vehicle.plVehicleCode = item.plVehicleCode
          this.prev.vehicle.lens = item.lens
        }
      })
    },
    'form.start.coordinate': function () {
      if (this.readOnly.fromApi || this.stopNoDisAndTm) {
        return;
      }
      this.calcDisAndTm()
    },
    'form.end.coordinate': function () {
      if (this.readOnly.fromApi || this.stopNoDisAndTm) {
        return;
      }
      this.calcDisAndTm()
    },
    'form.stops': {
      handler: function (val) {
        if (this.readOnly.fromApi || this.stopNoDisAndTm) {
          return;
        }
        if(val.length > 0) {
          let l = val.length, hasEmpty = false
          for(let i=0; i<l; i++) {
            if(!val[i].coordinate) {
              hasEmpty = true
              return
            }
          }
          if(!hasEmpty) {
            this.calcDisAndTm()
          }
        }else{
          this.calcDisAndTm()
        }
      },
      deep: true
    },
    'form.start.planSendtm': function () {
      if (this.readOnly.fromApi || this.stopNoDisAndTm) {
        return;
      }
      this.calcDisAndTm();
      this.calcTotoalRunTm();
      this.calcPrice();
      this.checkAndQueryDriverInfo();
    },
    'form.end.planArriveTm': function () {
      this.calcTotoalRunTm();
    },
    'form.totalLineDistance': function () {
      this.calcPrice();
    },
    'form.expectedPrice': _.debounce(function (val) {
      // this.totalFee = null
      if(val) {
        let tpl = val.toString().replace(/[^0-9.]/g, '')
        if(tpl > window.maxExpectedPrice || parseFloat(tpl) === 0){
          this.totalFee = null
          return false;
        }else{
          this.calcPrice();
        }
      }
    }, 1000),
    'activeTabName': _.debounce(function () {
      this.totalFee = null
      this.calcPrice()
    }, 300),
    'form.carrierType': _.debounce(function () {
      this.calcPrice()
    }, 1000),
    'tenantId': function (val) {
      this.form.tenantId = val;
    },
    'userId': function (val) {
      this.form.userId = val;
    },
    'telephone': function (val) {
      this.form.start.orderPlacerPhone = val;
    }
  },
  computed: {
    ...mapGetters([
      "hasrequesSensitAdressList",
      "sensitiveAdressList"
    ]),
    mode: function () {
      let mode = null;
      switch (this.prev.modes) {
        case '1': mode = '1'; break;
        case '2':
        case '3':
        case '1,2':
        case '1,3':
        case '2,3':
        case '1,2,3': mode = '2'; break;
        default: mode = '2'; break;
      }
      return mode
    },
    tenantId: function () {
      return this.$store.state.login.tenantId;
    },
    userId: function () {
      return this.$store.state.login.userId;
    },
    userName: function () {
      return this.$store.state.login.userName;
    },
    telephone: function () {
      return this.$store.state.login.telephone;
    },
    rules(){
          // 手机号校验
    const checkPhone = getCheckPhone();
    const checkSelect = (rule, value, callback) => {
      setTimeout(()=>{
        if(!value || this.selectItem.length === 0){
          return callback(new Error("请输入承运公司"),)
        }
        return callback()
      },600)
    };

      const _rules =     {
        processReason: [{ required: true, message: "请选择修改原因", trigger: "change" }],
  
        'start.addrDetail': [{ required: true, message: "请输入发货地址", trigger: "change" }],
        'start.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
        'start.orderPlacerPhone': [{ required: true, trigger: "blur", validator: checkPhone }],
        'start.planArriveTm': [{ required: true, message: "请输入到场时间", trigger: "change" }],
        'start.planSendtm': [{ required: true, message: "请输入计划发车时间", trigger: "change" }],
  
        'end.addrDetail': [{ required: true, message: "请输入收货地址", trigger: "change" }],
        'end.orderPlacerName': [{ required: true, message: "请输入联系人名称", trigger: "change" }],
        'end.orderPlacerPhone': [{ required: true, trigger: "blur", validator: checkPhone }],
        'end.planArriveTm': [{ required: true, message: "请选择计划到达时间", trigger: "change" }],
  
        cargoInfo: [{ required: true, message: "请选择货物信息", trigger: "change" }],
        cargoWeight: [{ required: true, message: "请输入货物重量", trigger: "change" }],
        cargoVolume: [{ required: true, message: "请输入货物体积", trigger: "change" }],
        dataOwner: [{ required: true, message: "请选择订单归属", trigger: "change" }],
  
        receiptAddress: [{ required: true, message: "请输入签收地址", trigger: "change" }],
        receiptName: [{ required: true, message: "请输入联系人姓名", trigger: "change" }],
        receiptPhone: [{ required: true, trigger: "blur", validator: checkPhone }],
  
        'carrierType': [{ required: true, message: "请选择承运对象", trigger: "change" }],
        'assignDriverParam.driverName': [{ required: true, message: "请输入承运司机", trigger: "change" }],
        'assignDriverParam.vehicleId': [{ required: true, message: "请选择承运车辆", trigger: "change" }],
        'assignCarrierParam.carrierName': [{ required: true,  trigger: "change",validator:checkSelect }],
  
        expectedPrice: [{ 
          required: true, 
          message: "请输入期望运费", 
          trigger: "change",
          validator: (rule, value, callback) => {
            // 只有在expectedPriceDisabled为true时才跳过校验
            if (this.expectedPriceDisabled) {
              callback();
            } else if (value === '' || value === null || value === undefined) {
              callback(new Error("请输入期望运费"));
            } else {
              callback();
            }
          }
        }],
        biddenStartTm: [{ required: true, message: "请输入竞价开始时间", trigger: "change" }],
        biddenEndTm: [{ required: true, message: "请输入竞价结束时间", trigger: "change" }],
        
        quantity: [
          {
            trigger: "change",
            required: false,
            validator: (rule, value, callback) => {
              if (value !== "") {
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false) {
                  callback(new Error("请填写大于0的数字"));
                } else {
                  if (Number(value) == 0) {
                    callback(new Error("请填写大于0的数字"));
                  } else {
                    callback();
                  }
                }
              } else {
                callback();
              }
            }
          }
        ]
      }
      if (this.activeTabName !== 'first' ) {
        _rules.tradeClient= [{ required: true, message: "请选择交易方式", trigger: "change" }]
      } else {
        delete _rules.tradeClient
      }
      return _rules
    },
    tradeClientOptions() {
      const vehicle_usage_mode = window._CONFIG_.vehicle_usage_mode
      const tradeOption = this.isSx ? vehicle_usage_mode.shunXin : vehicle_usage_mode.shunLu
      let _options = []
      switch(this.activeTabName) {
          case 'first': 
          _options = tradeOption.assign()
          break;
          case 'second': 
          _options = tradeOption.fixedPrice()
          break;
          case 'third': 
          _options = tradeOption.bidding()
          break;
      }
      return _options
    },
    // 禁用期望运费
    expectedPriceDisabled() {
      // 修改订单-详情接口返回serviceScene=201/202，禁用期望运费
      if (this.disableExpectedPriceByServiceScene) {
        return true;
      }
      // 只在指派用车tab下，且承运对象是个人，且存在driverInfoRemarks时返回true
      return this.activeTabName === 'first' && this.form.carrierType === 1 && !!this.driverInfoRemarks
    }
  },
  mounted() {
    if(!this.hasrequesSensitAdressList) {
      this.getSensitiveAddr({})
    }
    this.form.userId = this.$store.state.login.userId
    this.form.tenantId = this.$store.state.login.tenantId
    this.checkSmeSaasContract();
    this.queryNotSignedContract();
    this.queryAddressList();
    this.queryCarTypeList();
    Promise.all([this.initPlaceApiIns, this.queryAddressApiIns, this.queryAddressApiIns2, this.queryCarTypeListApiIns]).then(res => {
      this.initFinishCallBack1();
      this.initFinishCallBack2();
      this.initFinishCallBack3();
    })
    this.getTempOrder();
     this.setTradeClient(); 
  },
  created() {
    let menuInterval = setInterval(() => {
      let map = JSON.parse(sessionStorage.getItem('menuMap'))
      if (map) {
        clearInterval(menuInterval)
        let submenuList = map['Shipments'].split('-');
        submenuList.forEach((item, i) => {
          this.show[item] = true;
          i == 0 && (this.activeTabName = submenuList.indexOf('SendOrder') > -1 ? 'first' : 'second')
        });
      }
    }, 30);

    this.initPlaceApiIns = this.initPlaceApi({}).then(res => {
      this.prev.cargoInfos = res.cargoInfos
      this.prev.dataOwner = res.dataOwner
      this.prev.modes = res.modes
      this.prev.ownerName = res.ownerName
      this.prev.placerNames = res.placerNames

      this.form.start.orderPlacerName = res.placerNames[0]
      if (res.dataOwner.length == 1) {
        this.form.dataOwner = res.dataOwner[0].value
      }
    }).catch(e => { });

    let time = moment().add(5, 'minutes').format("YYYY-MM-DD HH:mm")
    this.form.biddenStartTm = time + ':00'
    this.isShunXin().then(res => {
      this.isSx = res
    })
  },
  methods: {
    ...mapActions([
      'addAddressApi',
      'queryAddressApi',
      'queryAddrByCoordinateApi',
      'queryAddrByKeywordApi',
      'initPlaceApi',
      'calcDisAndTmApi',
      'calcPriceApi',
      'placeOrderResApi',
      'getDriverInfoApi',
      'getCarrierInfoApi',
      'queryCarTypeListApi',
      'getOrderAlterInfoApi',
      'uploadToSaveOrderApi',
      'updateOrderApi',
      'getWaitHandleOrderByIdApi',
      'thirdPlaceOrderResApi',
      'queryNotSignedContractApi',
      'searchProjectOptionApi',
      'getExprecePriceApi',
      'getSensitiveAddr',
      'isShunXin',
      'queryDriverInfo',
    ]),
    // 判断是否上海疫情保障临时货主
    getTempOrder() {
      fetchGet("/saas/customer/queryCustomerIdentifier").then(res => {
        if(res && res === 'yqly'){
          this.isTempOrder = true
        }else{
          this.isTempOrder = false
        }
      }).catch(e => {
        this.isTempOrder = false
      })
    },
    // 项目名称下拉选项获取
    xmmcOptionGet(val) {
      this.searchProjectOptionApi({'reachTm':val}).then(res => {
        if(res){
          this.projectCodeOptions = res
        }else{
          this.projectCodeOptions = []
        }
      }).catch(e => {
        this.projectCodeOptions = []
      }).finally(() => {})
    },
    // 开始的到场时间变化
    dcTimeChange(val) {
      this.xmmcOptionGet(val)
    },
    checkSmeSaasContract(){
      let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      fetchGet("/saas/customer/checkSmeSaasContract/" + userInfo.tenantId)
      .then(
        res => {
          let data = res.response;
         this.IScontract = data.contract;
         this.ISsme = data.sme;
         //contract(合同是否有效)检测货主尚未有主合同，则弹窗提示 true表示有有效合同并已经签署 false是可能没有合同，可能有合同没有签署
         //sme(是否是SME客户),如果是，用车信息栏限定为指派用车
         if(this.ISsme){
          this.show.RobOrder = false;
          this.show.BidOrder = false;
         }
        }
      );
    },
    queryNotSignedContract() {
      this.queryNotSignedContractApi({}).then(res => {
        //console.log(res, 123)
        if(res){
          this.contractRow.id = res[0];
          if(this.contractRow.id){
            this.signDialogVisible = true;
          }
        }
      });
    },
    signDialogClose(){
      this.notSigned = true;
    },
    sign(){
      if(this.contractRow.id){
        this.$refs.contractContent.queryContractInfo(this.contractRow.id);
        this.signDialogVisible = false;
      }
    },
    cancel(){
      this.signDialogVisible = false;
      this.notSigned = true;
    },
    signedSuccessfully(){
      this.notSigned = false;
      this.IScontract = true;
      this.queryNotSignedContract();
    },
    biddenEndTmBlur() {
      if (!this.form.biddenStartTm || !this.form.biddenEndTm) {
        this.bidDays = ''
        this.bidHours = ''
        this.bidMinutes = ''
        return;
      } else {
        let a = moment(this.form.biddenStartTm)
        let b = moment(this.form.biddenEndTm)
        let m = b.diff(a, 'minutes')
        if (m > 0) {
          let days = moment.duration(m, 'minutes').days()
          let hours = moment.duration(m, 'minutes').hours()
          let minutes = moment.duration(m, 'minutes').minutes()
          this.bidDays = days
          this.bidHours = hours
          this.bidMinutes = minutes
        } else {
          this.$message({
            type: 'warning',
            message: '竞价结束时间必须大于开始时间'
          })
          this.bidDays = ''
          this.bidHours = ''
          this.bidMinutes = ''
          return;

        }
      }
    },
    calcEndTime() {
      if (!this.form.biddenStartTm) return;
      let total = 0;
      total = parseInt(this.bidDays ? this.bidDays : 0) * 24 * 60 + parseInt(this.bidHours ? this.bidHours : 0) * 60 + parseInt(this.bidMinutes ? this.bidMinutes : 0)
      this.form.biddenEndTm = moment(this.form.biddenStartTm).add(total, 'minutes').format('YYYY-MM-DD HH:mm:ss')
    },
    limitNumber(val, oldValue) {
      let tpl = ("" + val)  //转成字符串
        .replace(/[^\d^\.]+/g, "")  //把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1")  //第一位0开头，0后面为数字，则过滤掉，去后面的数字
        .replace(/^\./, "0.")  //如果输入的第一位为小数点，则替换成0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || "";  //最终匹配得到的结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      this.form.expectedPrice = tpl;
      if (parseFloat(tpl) > window.maxExpectedPrice) {
        this.inputFlag = true;
        this.inputErrorMsg = `填写期望运费金额过大，不可超过${window.maxExpectedPrice}元`
      } else if (parseFloat(tpl) === 0) {
        this.inputFlag = true;
        this.inputErrorMsg = `请在0元~${window.maxExpectedPrice}元范围内填写期望运费金额`
      } else {
        this.inputFlag = false;
        this.inputErrorMsg = ""
      }
    },
    onAlterOrder() {
      if (this.inputFlag) {
        this.$message.error(this.inputErrorMsg);
        return
      }
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.checkTm()) return;
          let params = Object.assign({}, this.form);
          this.isOrdering = true
          params.saasPassZoneVOs = [params.start, ...params.stops, params.end];
          params.reachTm = params.start.planArriveTm;
          params.receiptType = (params.needReceipt == 3 ? 2 : params.needReceipt == 1 ? 1 : '');
          params.needReceipt = (params.needReceipt == 2 ? 2 : 1);

          if (this.activeTabName == 'second' || this.activeTabName == 'third') {
            params.carrierAssignFlag = 'N'
            params.vehicleType = this.prev.vehicle.plVehicleCode
            params.vehicleLength = this.prev.vehicle.vehicleLength
            params.mode = '';
          } else {
            params.carrierAssignFlag = 'Y'
            if (params.carrierType == '2') {
              params.vehicleType = this.prev.vehicle.plVehicleCode
              params.vehicleLength = this.prev.vehicle.vehicleLength
            }
            params.mode = this.mode;

          }

          if (this.activeTabName == 'second') {
            params.dispatchMode = 1
          } else if (this.activeTabName == 'third') {
            params.dispatchMode = 2
          } else {
            params.dispatchMode = 0
          }

          delete params.start;
          delete params.stops;
          delete params.end;
          delete params.def;
          delete params.addedComments;
          delete params.assignDriverParam.carList
          delete params.assignDriverParam.list
          delete params.assignDriverParam.vehicleId

          let flag = true
          for (let i = 0; i < params.saasPassZoneVOs.length - 1; i++) {
            if (!this.compareTime(params.saasPassZoneVOs[i].planSendtm, params.saasPassZoneVOs[i + 1].planArriveTm)) {
              this.$message({
                type: 'warning',
                message: '下一地点的计划到达时间必须大于上一地点的发车时间'
              })
              flag = false;
              break;
            }
          }
          if (!flag) {
            this.isOrdering = false
            return;
          }
          params.orderId = this.alterOrderId
          this.updateOrderApi(params).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.state = 3
            Object.assign(this.form, this.$options.data().form)
            this.form.userId = this.$store.state.login.userId
            this.form.tenantId = this.$store.state.login.tenantId
            this.totalFee = ''
            this.form.uuid = ''
            this.updateSuccRes.orderId = res.orderId
            this.updateSuccRes.version = res.version

          }).catch(e => { }).finally(() => {
            this.isOrdering = false
          })
        }
      })
    },
    initFinishCallBack1() {
      this.handleUsualLineJump();
    },
    initFinishCallBack2() {
      this.alterOrderId = sessionStorage.getItem('alterOrderId')
      if (this.alterOrderId) {
        sessionStorage.removeItem('alterOrderId')
        this.isAlter = true
        this.getOrderAlterInfo();
      }
    },
    initFinishCallBack3() {
      this.handleWaitHandleOrderJump();
      let shipmentsObj = window.sessionStorage.getItem('stopHandleOrderParams');
      if(shipmentsObj) {
        this.handleStopHandleOrderJump();
      }
    },
    getOrderAlterInfo() {
      this.getOrderAlterInfoApi({ orderId: this.alterOrderId }).then(res => {
        this.isAlter_firstTrigger = true
        // 检查serviceScene字段，如果是201或202，设置禁用期望运费
        if (res.serviceScene === 201 || res.serviceScene === 202) {
          this.disableExpectedPriceByServiceScene = true;
        } else {
          this.disableExpectedPriceByServiceScene = false;
        }
        this.fillOrderForm(res)
        setTimeout(() => { this.isAlter_firstTrigger = false }, 100)
      }).catch(e => { });
    },
    fillOrderForm(res) {
      let dto = res.orderEditAddrDtos
      Object.assign(this.form.start, dto[0])
      Object.assign(this.form.end, dto[dto.length - 1])
      this.form.stops = [...dto.slice(1, dto.length - 1)]

      this.form.cargoInfo = res.cargoInfo
      this.form.cargoWeight = res.cargoWeight
      this.form.cargoVolume = res.cargoVolume
      this.form.outerOrderId = res.outerOrderId ? res.outerOrderId : ''
      this.form.cargoComment = res.cargoComment ? res.cargoComment : ''

      this.form.dataOwner = res.dataOwner
      this.form.comment = res.comment
      this.form.needReceipt = res.needReceipt
      this.form.receiptAddress = res.receiptAddress
      this.form.receiptName = res.receiptName
      this.form.receiptPhone = res.receiptPhone

      // this.activeTabName = (res.dispatchMode == 0 ? 'first' : 'other')
      switch(res.dispatchMode) {  //("指派用车", 0), ("一口价找车", 1), ("竞价找车", 2), ("招标用车", 3), ("询报价", 4), ("平台找车", 5);
        case 0:
          this.activeTabName = 'first';
          break;
        case 1:
          this.activeTabName = 'second';
          break;
        case 2:
          this.activeTabName = 'third';
          break;
        default:
          this.activeTabName = '';
          break;
      }
      this.form.carrierType = res.carrierType
      this.form.projectCode = res.projectCode
      this.form.expectedPrice = res.price
      this.totalFee = res.totalPrice
      this.form.totalPrice = ('' + res.totalPrice)
      this.readOnly.fromApi = res.fromApi
      this.form.totalLineDistance = res.distance
      // 如果为长期单，期望运费（含税）不允许修改
      if(res.requireType == 1) {
        this.form.isLongOrder = true
      }
    },
    onTriggerFile() {
      this.$refs.batchFile.dispatchEvent(new MouseEvent('click'))
    },
    eFileChange() {
      let dom = this.$refs.batchFile
      let file = dom.files[0]
      if (file) {
        this.changed = true
        let name = file.name
        let size = file.size
        let type = file.type
        this.filename = file.name
        this.uploadBtn = false
      } else {
        this.changed = false
        let name = null;
        let size = null;
        let type = null;
        this.filename = null;
        this.uploadBtn = true;
      }
    },
    beforeUpload(file) {
      let name = file.name.toUpperCase();
      const isExcel = name.slice(-'XLSX'.length) == 'XLSX';
      const isLt10M = file.size / 1024 / 1024 < 1;
      if (!isExcel) {
        return '上传文件只能是 xlsx 格式!';
      }
      if (!isLt10M) {
        return '上传文件大小不能超过 1MB!';
      }
      return null;
    },
    handleSuccess(res, file) {
      console.log(res, file)
    },
    handleRemove() { },
    clearUploadFile() {
      document.getElementById('cmFile').value = '';
      this.filename = '';
      this.changed = false;
      this.uploadBtn = true;
    },
    submitUpload() {
      if (!document.getElementById('cmFile').files[0]) {
        this.$message({
          type: "error",
          message: '请选择文件！'
        });
        return;
      }
      let beforeUploadResult = this.beforeUpload(document.getElementById('cmFile').files[0]);
      if (beforeUploadResult) {
        this.$message({
          type: "error",
          message: beforeUploadResult
        });
        return;
      }
      this.uploadUsualLineLoading = true;
      let formData = new window.FormData();
      formData.append('cmFile', document.getElementById('cmFile').files[0]);
      if(this.isTempOrder) {
        formData.append('param',JSON.stringify({'uploadGoodsDetail':true}));
      }
      this.uploadToSaveOrderApi(formData).then(res => {
        debugger
        this.uploadUsualLineLoading = false;
        const {result, succ } = JSON.parse(res.request.response);
        if (succ === 'fail') {
          this.$message({
            type: "error",
            message: res.data.msg
          });
          return;
        }
        
        let tip = "导入成功记录数" + result.succSum + "条,导入失败记录数" + result.failSum + "条,详情请查看附件!";
        this.$notify({
          title: '提示',
          message: tip,
          type: 'warning',
          duration: 15000
        });
        this.clearUploadFile();
        let preUrl = getMvcUrl() + '/saas/downLoad/downLoadOssFile?objectName=' + result.filePath;
        window.open(preUrl);
      }).catch(e => {
        if (e && e.succ === 'fail' && e.msg) {
          this.$message({
            type: "error",
            message: e.msg
          });
        }
        this.uploadUsualLineLoading = false;
      }).finally(() => { });
    },
    handletTabClick() { },
    calcTotoalRunTm() {
      let a = moment(this.form.start.planSendtm)
      let b = moment(this.form.end.planArriveTm)
      let m = b.diff(a, 'minutes')
      if (this.form.start.planSendtm && this.form.end.planArriveTm && m > 0) {
        let days = moment.duration(m, 'minutes').days()
        let hours = moment.duration(m, 'minutes').hours()
        let minutes = moment.duration(m, 'minutes').minutes()
        this.form.totalRunTm = m
        this.form.def.days = days
        this.form.def.hours = hours
        this.form.def.minutes = minutes
      }
    },
    compareTime(startTm, endTm) {
      let result = moment(endTm).diff(moment(startTm), 'minutes')
      return result > 0;
    },
    onCheckDetail() {
      this.$router.push('/manage/OrderList')
    },
    onCheckOrderDeal() {
      sessionStorage.setItem('alterOrderId', this.updateSuccRes.orderId)
      sessionStorage.setItem('version', this.updateSuccRes.version)
      this.$router.push('/manage/OrderProcess')
    },
    onToOrderManage() {
      this.$router.push('/manage/OrderList')
    },
    onContinue() {
      this.state = 1;
    },
    queryCarTypeList() {
      this.queryCarTypeListApiIns = this.queryCarTypeListApi({}).then(res => {
        this.prev.vehicle.Maps = res;
        this.prev.vehicle.typeMapLens = res.typeMapLens;
        this.prev.vehicle.lens = res.lens;
      })
    },
    onOpenAddAddresss() {
      this.$refs.newAddressFormRef.resetFields();
    },
    oncloseAddAddresss() {
      this.$refs.newAddressFormRef.resetFields();
    },
    onAddAddress() {
      this.addAddressVisible = true
    },
    onAddAddressconfirm() {
      let params = Object.assign({}, this.newAddress)
      params.address = params.addrDetail
      delete params.addrDetail
      delete params.rules

      this.$refs.newAddressFormRef.validate((valid) => {
        if (valid) {
          this.addAddressApi(params).then(res => {
            this.$message({
              type: 'success',
              message: '新增成功'
            });
            this.addAddressVisible = false
            this.queryAddressList()
          })
        }
      })
    },
    querySearch(qs, cb) {
      let list = this.addressList;
      let results = qs ? list.filter(this.filterFun(qs)) : list;
      cb(results);
    },
    filterFun(qs) {
      return (item) => {
        return (item.shortName && item.shortName.indexOf(qs) !== -1) || item.address.indexOf(qs) !== -1 || item.contacts.indexOf(qs) !== -1 || item.phone.indexOf(qs) !== -1;
      }
    },
    handleSelect(item, obj) {
      obj.addrDetail = item.address
      obj.cityCode = item.cityCode
      obj.cityName = item.cityName
      obj.coordinate = item.coordinate
      obj.orderPlacerPhone = item.phone
      obj.orderPlacerName = item.contacts

    },
    queryAddressList() {
      this.queryAddressApiIns = this.queryAddressApi({ pageSize: 10000, pageNum: 1 }).then(res => {
        this.addressList = res.rows
      }).catch(e => { })
      this.queryAddressApiIns2 = this.queryAddressApi({ pageSize: 10000, pageNum: 1, addrType: 2 }).then(res => {
        this.recAddressList = res.rows
      }).catch(e => { })
    },
    mapCarrierStatus(status) {
      let res = '';
      switch (status) {
        case 1: res = '注册审核驳回'; break;
        case 2: res = '启用'; break;
        case 3: res = '草稿'; break;
        case 4: res = '待注册审核'; break;
        case 5: res = '黑名单'; break;
        case 11: res = '考察审核驳回'; break;
        case 12: res = '准入审核驳回'; break;
        case 41: res = '待考察审核'; break;
        case 42: res = '待准入审核'; break;
        case 7: res = '招投标黑名单'; break;
        case 8: res = '已退出'; break;
        default: res = '其他'; break;
      }
      return res
    },
    onSearchDriver(queryString) {
      if (!queryString) {
        this.driverOptions = []
        return
      }
      let params = {
        name: queryString,
        mode: '',
        planSendTm: (this.form.start.planSendtm ? this.form.start.planSendtm : this.currentTm)
      }
      this.form.assignDriverParam.carList = [];
      this.driverLoading = true
      this.getDriverInfoApi(params).then(res => {
        this.effectLoadCapacity = ''
        this.form.assignDriverParam.list = res
        let list = this.form.assignDriverParam.list;
        this.driverLoading = false
        const driverOptions = queryString ? list.filter(this.createFilter(queryString)) : list;
        this.driverOptions = driverOptions.map(ele => {
          return {
            ...ele,
            disabled: ele.latestCont !== 1
          }
        })
      })
    },
    createFilter(queryString) {
      return (item) => {
        return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || item.mobilephone.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    onhandFocusDriver () {
      if (this.form.assignCarrierParam.driverName) {
        this.driverOptions = JSON.parse(JSON.stringify(this.cacheDriverOptions || []))
      }
    },
    onhandDriverVisibleChange (visible) {
      if (!visible && !this.form.assignCarrierParam.driverName) {
        this.driverOptions = []
        this.cacheDriverOptions = []
      }
    },
    onhandSelectDriver(val) {
      const item = this.driverOptions.find(ele => ele.userId === val)
      if (this.form.assignCarrierParam.driverName) {
        this.cacheDriverOptions = JSON.parse(JSON.stringify(this.driverOptions || []))
      }
      if (item.status != 1) {
        this.$message({
          type: 'warning',
          message: '司机未认证，请通知司机在顺陆APP进行信息验证'
        })
        /* this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        }); */
        return;
      }
      if (item.latestCont != 1) {
        return
      }
      this.form.assignDriverParam.driverName = item.name
      this.form.assignDriverParam.driverId = item.driverId
      this.form.assignDriverParam.driverPhone = item.mobilephone
      this.form.assignDriverParam.userId = item.userId
      this.form.assignDriverParam.userName = item.userName
      this.form.assignDriverParam.carList = this.addFieldToCarList(item.vehicleList)
      this.driverTag = item.driverTag
      this.cysjClikFlag = true
      this.checkAndQueryDriverInfo()
    },
    myDriverChange() {
      this.cysjClikFlag = false
    },
    myDriverBlur() {
      if(!this.cysjClikFlag) {
        this.form.assignDriverParam.driverName = ''
        this.form.assignDriverParam.driverId = null
        this.form.assignDriverParam.driverPhone = ''
        this.form.assignDriverParam.userId = ''
        this.form.assignDriverParam.userName = ''
        this.form.assignDriverParam.carList = []
        this.driverTag = ''
        this.cysjClikFlag = false
      }
    },
    addFieldToCarList(list) {
      if (list.length > 0) {
        list.forEach(item => {
          let state = item.status == 1 ? '已认证' : item.status == 2 ? '未认证' : '被占用'
          item.label = item.vehicleCode + '（' + item.vehicleTypeName + ' ' + item.vehicleLength + '米 ）' + state
          if (item.status != 1) {
            item.disabled = true
          }
        })
        return list;
      }
    },
    onhandFocusCarrier () {
      if (this.form.assignCarrierParam.carrierName) {
        this.carrierOptions = JSON.parse(JSON.stringify(this.cacheCarrierOptions || []))
      }
    },
    onhandCarrierVisibleChange (visible) {
      if (!visible && !this.form.assignCarrierParam.carrierName) {
        this.carrierOptions = []
        this.cacheCarrierOptions = []
      }
    },
    handleProjectChange () {
      this.form.assignCarrierParam.carrierName = ''
      this.carrierOptions = []
    },
    onSearchCarrier(queryString) {
      let params = { name: queryString, projectCode: this.form.projectCode }
      if (!queryString) {
        this.carrierOptions = []
        return;
      }
      this.carrierLoading = true
      this.getCarrierInfoApi(params).then(res => {
        let list = res;
        let results = queryString ? list.filter(this.createFilter2(queryString)) : list;
        this.selectItem = results;
        if(results.length === 0){
          this.selectItem = []
        }
        this.carrierOptions = results.map(ele => {
          return {
            ...ele,
            disabled: ele.latestCont !== 1
          }
        })
        this.carrierLoading = false
      })
    },
    createFilter2(queryString) {
      return (item) => {
        return (item.blName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    onhandSelectCarrier(val) {
      const item = this.carrierOptions.find(ele => ele.blName === val)
      if (this.form.assignCarrierParam.carrierName) {
        this.cacheCarrierOptions = JSON.parse(JSON.stringify(this.carrierOptions || []))
      }
      if (item.latestCont != 1) {
        return
      }
      this.form.assignCarrierParam.carrierId = item.id
      this.form.assignCarrierParam.carrierName = item.blName
      // this.form.assignCarrierParam.type = item.type
      this.form.assignCarrierParam.userName = item.userName
      this.form.assignCarrierParam.userId = item.userId
      this.cygsClickFlag = true
    },
    myCompanyChange() {
      this.cygsClickFlag = false
    },
    myCompanyBlur() {
      if(!this.cygsClickFlag) {
        this.form.assignCarrierParam.carrierId = null
        this.form.assignCarrierParam.carrierName = ''
        this.form.assignCarrierParam.userName = ''
        this.form.assignCarrierParam.userId = ''
        this.cygsClickFlag = false
      }
    },
    onCarSelect(id) {
      this.form.assignDriverParam.carList.forEach(item => {
        if (id == item.vehicleId) {
          this.form.vehicleType = item.vehicleType
          this.form.vehicleLength = item.vehicleLength
          this.form.assignDriverParam.vehicleSerial = item.vehicleCode
          this.effectLoadCapacity = item.effectLoadCapacity
          /* 保存 */
          this.sx.vehicleTypeName = item.vehicleTypeName
          this.sx.vehicleLength = item.vehicleLength
        }
      })
      this.checkAndQueryDriverInfo()
    },
    checkTm() {
      let validTmRes = true
      if (!this.compareTime(this.form.start.planArriveTm, this.form.start.planSendtm)) {
        validTmRes = false
      }
      this.form.stops.forEach(item => {
        if (!this.compareTime(item.planArriveTm, item.planSendtm)) {
          validTmRes = false
        }
      });
      if (!validTmRes) {
        this.$message({
          type: 'warning',
          message: '计划发车时间必须大于到场时间'
        })
        return validTmRes
      }
      return true
    },
    async checkWaitHandleOrder() {
      if (!this.checkWaitHandleOrderVehicleInfo()) {
        return false;
      }
      if (!await this.checkWaitHandleOrderStatus()) {
        return false;
      }
      return true;
    },
    checkWaitHandleOrderVehicleInfo() {
      if (this.invokeSource === 'waitHandelOrder' && this.activeTabName === 'first' && this.show.SendOrder && this.form.carrierType == 1) {
        if (this.prev.vehicle.plVehicleCode && this.prev.vehicle.vehicleLength && this.form.assignDriverParam.vehicleId) {
          for (let i = 0; i < this.form.assignDriverParam.carList.length; i++) {
            if (this.form.assignDriverParam.carList[i].vehicleId == this.form.assignDriverParam.vehicleId) {
              if (this.form.assignDriverParam.carList[i].vehicleType != this.prev.vehicle.plVehicleCode) {
                this.$message({
                  type: 'error',
                  message: '承运车辆的车型不符合用车要求'
                });
                return false;
              }
              if (this.form.assignDriverParam.carList[i].vehicleLength * 1 < this.prev.vehicle.vehicleLength * 1) {
                this.$message({
                  type: 'error',
                  message: '承运车辆的车长不符合用车要求'
                });
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    async checkWaitHandleOrderStatus() {
      if (this.invokeSource !== 'waitHandelOrder') {
        return true;
      }
      let params = {};
      params.id = this.waitHandelOrderId;
      try {
        const res = await this.getWaitHandleOrderByIdApi(params)
        if (res.status != 0 && res.status != 3) {
          this.$message({
            type: "error",
            message: '该订单状态为已处理或已取消,不允许发货'
          });
          return false;
        } else {
          return true;
        }
      } catch (e) {
        if (e && e.succ === 'fail' && e.msg) {
          this.$message({
            type: "error",
            message: e.msg
          });
        }
        this.$message({
          type: "error",
          message: '无法获取该订单状态,不允许发货'
        });
        return false;
      }
    },
    // 发布
    onPlaceOrder() {
      debugger
      if (this.contractRow.id) {
        this.signDialogVisible = true;
        return
      }
      if (this.inputFlag) {
        this.$message.error(this.inputErrorMsg);
        return
      }
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.checkTm()) return;
          if (!this.checkWaitHandleOrder()) {
            return;
          }
          let params = Object.assign({}, this.form);
          /* 待处理订单，车型车长校验 */
          if (this.invokeSource === 'waitHandelOrder') {
            if (this.activeTabName === 'first' && this.form.carrierType == 1 && this.prev.vehicle.vehicleType != this.sx.vehicleTypeName || parseFloat(this.prev.vehicle.vehicleLength) > parseFloat(this.sx.vehicleLength)) {
              this.$message({
                type: 'warning',
                message: '承运车辆与已选车型车长不一致，请调整'
              })
              return;
            } else {
              params.systemCode = this.systemCode;
            }
          }
          this.isOrdering = true;
          params.saasPassZoneVOs = [params.start, ...params.stops, params.end];
          params.reachTm = params.start.planArriveTm;
          params.receiptType = (params.needReceipt == 3 ? 2 : params.needReceipt == 1 ? 1 : '');
          params.needReceipt = (params.needReceipt == 2 ? 2 : 1);

          params.orderManageId = this.stopOrderManageId;
          params.oldOrderId = this.stopOrderId;

          if (this.activeTabName == 'second' || this.activeTabName == 'third') {
            params.carrierAssignFlag = 'N'
            params.vehicleType = this.prev.vehicle.plVehicleCode
            params.vehicleLength = this.prev.vehicle.vehicleLength
            params.mode = '';
          } else {
            params.carrierAssignFlag = 'Y'
            if (params.carrierType == '2') {
              params.vehicleType = this.prev.vehicle.plVehicleCode
              params.vehicleLength = this.prev.vehicle.vehicleLength
            }
            params.mode = this.mode;
          }

          if (this.activeTabName == 'second') {
            params.dispatchMode = 1
          } else if (this.activeTabName == 'third') {
            params.dispatchMode = 2
          } else {
            params.dispatchMode = 0
          }

          delete params.start;
          delete params.stops;
          delete params.end;
          delete params.def;
          delete params.addedComments;
          delete params.assignDriverParam.carList
          delete params.assignDriverParam.list
          delete params.assignDriverParam.vehicleId

          let flag = true
          for (let i = 0; i < params.saasPassZoneVOs.length - 1; i++) {
            if (!this.compareTime(params.saasPassZoneVOs[i].planSendtm, params.saasPassZoneVOs[i + 1].planArriveTm)) {
              this.$message({
                type: 'warning',
                message: '下一地点的计划到达时间必须大于上一地点的发车时间'
              })
              flag = false;
              break;
            }
          }
          if (!flag) {
            this.isOrdering = false
            return;
          }
          if (!params.totalLineDistance || params.totalLineDistance < 0 || params.totalLineDistance == 0) {
            this.$message({
              type: 'warning',
              message: '请输入正确的总里程'
            })
            this.isOrdering = false
            return;
          }

          let commonPlaceOrderApi = null;
          if (this.thirdPlaceOrder) {
            commonPlaceOrderApi = this.thirdPlaceOrderResApi;
          } else {
            commonPlaceOrderApi = this.placeOrderResApi;
          }
          commonPlaceOrderApi(params).then(res => {
            Object.assign(this.form, this.$options.data().form)
            this.form.userId = this.$store.state.login.userId
            this.form.tenantId = this.$store.state.login.tenantId
            this.totalFee = ''
            this.form.uuid = ''

            if (res.result) {
              this.state = 2
              sessionStorage.setItem('orderId', res.result)
              this.$message({
                type: 'success',
                message: '下单成功'
              })
            } else {
              this.state = 4
              this.approvalMsg = res.msg
              this.$alert(res.msg, '温馨提示', {
                confirmButtonText: '确定',
                type: 'warning',
                callback: () => {}
              });
            }
          }).catch(e => { }).finally(() => {
            this.isOrdering = false
          })
        }
      })
    },
    calcPrice() {
      // let price = this.form.expectedPrice
      // let driverTag = this.driverTag
      // let distance = this.form.totalLineDistance
      // let planSendTm = this.form.start.planSendtm ? this.form.start.planSendtm : this.currentTm
      // let type = this.form.carrierType == '2' ? 'B' : 'C'
      // let effectLoadCapacity = this.effectLoadCapacity
      let orderPrice = this.form.expectedPrice //货主填的价格  orderPrice
      let mileage = this.form.totalLineDistance  //里程  mileage
      let planSendTm = this.form.start.planSendtm //计划发车时间，格式 yyyy-MM-dd HH:mm:ss  planSendTm
      let activeTabName = this.activeTabName //0-派单/指派 1-抢单 2-竞价 4-询报价 10-全部  tradeMode
      let tradeMode = null
      switch(activeTabName) {
        case 'first':
          tradeMode = 0;
          break;
        case 'second':
          tradeMode = 1;
          break;
        case 'third':
          tradeMode = 2;
          break;
        default:
          tradeMode = null;
          break;
      }
      let projectCode = this.form.projectCode ? this.form.projectCode : null //项目名称代码  projectCode
      let role = this.form.carrierType //role 计费对象（角色）(0-C端 1-B端"=>0-个人 1-公司)(页面：1个人，2公司)
      switch(role) {
        case 1:
          role = 0;
          break;
        case 2:
          role = 1;
          break;
        default:
          role = null;
          break;
      }
      if(tradeMode != 0) {
        role = null;
      }
      let params = {
        orderPrice,
        mileage,
        planSendTm,
        tradeMode,
        projectCode,
        role
      }
      if (!orderPrice || !mileage || !planSendTm || !activeTabName || (tradeMode==0&&role==null)) {
        return;
      }
      this.getExprecePriceApi(params).then(res => {
        let price = res.totalFee
        if (price != '' && /^[\d.]+$/.test(price)) {
          this.totalFee = price
          this.form.totalPrice = ('' + price)
          return;
        }
      }).catch(e => {})
      // if (price != '' && /^[\d.]+$/.test(price)) {
      //   this.totalFee = price
      //   this.form.totalPrice = ('' + price)
      //   return;
      // }
      /* if (!price || !distance || this.activeTabName != 'first') {
        return;
      }
      if (type == 'B') {
        this.totalFee = price
        this.form.totalPrice = ('' + price)
        return;
      }
      this.calcPriceApi(params).then(res => {
        this.totalFee = res.price
        this.form.uuid = res.uuid
        this.form.totalPrice = ('' + res.price)
      }).catch(e => { }) */
    },
    onTabsClick(tab, event) {
      console.log(tab, event);
      this.setTradeClient();
    },
    setTradeClient(){
      // if (this.isSx) {
      //   this.form.tradeClient = this.activeTabName === 'first' ? 'BC' : 'B'
      // } else {
      //   this.form.tradeClient = 'BC'
      // }
      const items = this.tradeClientOptions
      this.form.tradeClient = items.length ? items[0].value : ''
    },
    onAddComment(item) {
      if (this.form.addedComments.indexOf(item) == -1) {
        this.form.addedComments.push(item)
      } else {
        this.form.addedComments.pop(item)
      }
      this.form.comment = this.form.addedComments.join(' ')
    },
    onAddStop() {
      if(this.form.stops.length == 10) {
        if(this.form.isLongOrder) {
          this.$message({
            type: 'warning',
            message: '最多添加10个经停点'
          })
          return;
        }
      }
      if (this.form.stops.length == 50) {
        this.$message({
          type: 'warning',
          message: '最多添加50个经停点'
        })
        return;
      }
      let sortNum = this.form.stops.length + 2
      let stop = {
        "addrDetail": "",
        "cityCode": "",
        "cityName": "",
        "coordinate": "",
        "jobType": null,
        "lineDistance": '',
        "orderPlacerName": "",
        "orderPlacerPhone": "",
        "planArriveTm": '',
        "planSendtm": '',
        "sortNum": sortNum
      }
      this.form.stops.push(stop);
      this.form.end.sortNum = sortNum + 1;
      this.stopNoDisAndTm = false;
    },
    onDeleteStop(index) {
      let sortNum = this.form.stops.length
      this.form.stops.splice(index, 1);
      this.form.stops.forEach((item, index) => {
        item.sortNum = index + 2
      })
      this.form.end.sortNum = sortNum + 1
      this.stopNoDisAndTm = false
    },
    emapopen(obj) {
      let nodelist = document.querySelectorAll(".el-autocomplete-suggestion.el-popper");
      for (let i = 0; i < nodelist.length; i++) {
        nodelist[i].style.display = "none";
      }
    },
    onOpenMap(obj, type) {
      if (this.readOnly.fromApi) {
        return;
      }
      if ('ignore' === type) {

      }
      else if ('start' === type) {
        if (this.readOnly.startAddrDetail) {
          return;
        }
      }
      else if ('end' === type) {
        if (this.readOnly.endAddrDetail) {
          return;
        }
      } else {
        if (this.invokeSource == 'waitHandelOrder' && this.stopsReadOnly[type].addrDetail) {
          return;
        }
      }
      this.mapVisible = true;
      this.map.currVo = obj;
    },
    eMapOpened() {
      this.$refs.keywordRef.focus();
      if (!this.map.mapIns) {
        this.map.mapIns = this.SFMap.map("map", {
          center: [22.524729, 113.940159],
          zoom: 15
        });
        this.map.vectorLayer = this.SFMap.vectorLayer({ map: this.map.mapIns });
        this.map.mapIns.on("click", this.onMapClick);
      }
    },
    eMapClosed() {
      this.map.coordinate = ''
      this.map.keyWord = ''
      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      this.removeMarkersList();
    },
    onMapClick(e) {
      this.map.coordinateLat = e.latlng.lat.toFixed(6);
      this.map.coordinateLon = e.latlng.lng.toFixed(6);
      let coordinate = this.map.coordinateLon + ',' + this.map.coordinateLat
      this.$message({
        type: 'info',
        message: '查询中...'
        , duration: 1000
      });
      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      this.map.markerTpl = this.SFMap.marker([this.map.coordinateLat, this.map.coordinateLon]);
      this.map.vectorLayer.addLayer(this.map.markerTpl);
      this.queryAddrByCoordinateApi({ coordinate: coordinate }).then(res => {
        this.fillMapInfo(res.name, res.city, res.regcode, coordinate, res.province, res.district)
      })
    },
    calcDisAndTm() {
      let srcCoordinate = this.form.start.coordinate
      let destCoordinate = this.form.end.coordinate
      let planDepartTm = this.form.start.planSendtm
      if (!srcCoordinate || !destCoordinate || !planDepartTm) {
        return;
      }
      if (this.isAlter_firstTrigger) return;
      if (this.is_shunxin_order && this.form.totalLineDistance) return;

      let planOrderPassZoneTbpList = []
      planOrderPassZoneTbpList.push({
        seq: this.form.start.sortNum,
        coordinate: this.form.start.coordinate
      })
      let l = this.form.stops.length;
      if(l) {
        for(let i=0; i<l; i++) {
          planOrderPassZoneTbpList.push({
            seq: this.form.stops[i].sortNum,
            coordinate: this.form.stops[i].coordinate
          })
        }
      }
      planOrderPassZoneTbpList.push({
        seq: this.form.end.sortNum,
        coordinate: this.form.end.coordinate
      })

      let params = {
        vehicleLength: 4.2,
        planOrderPassZoneTbpList
        // srcCoordinate,
        // destCoordinate,
        // planDepartTm
      }
      this.calcDisAndTmApi(params).then(res => {
        this.form.totalLineDistance = res.distance
        this.form.totalRunTm = res.tm
        let m = res.tm
        let days = moment.duration(m, 'minutes').days()
        let hours = moment.duration(m, 'minutes').hours()
        let minutes = moment.duration(m, 'minutes').minutes()
        this.form.def.days = days
        this.form.def.hours = hours
        this.form.def.minutes = minutes
        if (this.form.start.planSendtm) {
          //如果是待处理订单过来的并且目的地计划到车时间不为空，则不可以修改此字段的值
          if (this.invokeSource == 'waitHandelOrder' && this.readOnly.endPlanArriveTm) {
            return;
          }
          this.form.end.planArriveTm = moment(this.form.start.planSendtm).add(m, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        }
      })
      this.stopNoDisAndTm = false;
    },
    fillMapInfo(addrDetail, cityName, cityCode, coordinate, province, district) {
      this.map.cityName = cityName;
      this.map.addrDetail = addrDetail;
      this.map.cityCode = cityCode;
      this.map.coordinate = coordinate;
      this.map.inputCityName = cityName;
      this.map.keyWord = addrDetail;

      this.map.province = province;
      this.map.district = district;
    },
    addMarker(arr) {
      let layer = this.map.vectorLayer;
      arr.forEach((item, index) => {
        let address = item.name;
        let addrDetail = item.adname + item.shortName
        let province = ''
        let o = item.lnglat.split(',')
        let coord = [o[1], o[0]]
        if (index == 0) {
          this.moveMap(coord)
        }
        if (item.adname.indexOf('省') > 0) {
          province = ''
        } else {
          province = ''
        }
        let iconMarker = this.SFMap.marker(coord, {
          iconIndex: index + 1
        }).on("click", () => {
          this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
        }).bindTooltip(address);
        layer.addLayer(iconMarker);
        this.map.markersList.push(iconMarker);
      });
    },
    removeMarkersList() {
      if (this.map.markersList && this.map.markersList.length > 0) {
        for (let i = 0; i < this.map.markersList.length; i++) {
          this.map.vectorLayer.removeLayer(this.map.markersList[i]);
        }
        this.map.markersList = [];
      }
    },
    moveMap(coord) {
      this.map.mapIns.panTo(coord);
    },
    onhandleCommand(item) {
      let addrDetail = item.adname + item.shortName
      let o = item.lnglat.split(',')
      let coord = [o[1], o[0]]
      let province = ''
      if (item.adname.indexOf('省') > 0) {
        province = ''
      } else {
        province = ''
      }
      this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
      this.moveMap(coord)
    },
    queryTipByKeyword(cb) {
      let params = {
        'cityName': this.map.inputCityName,
        'keyWord': this.map.keyWord,
        noFailMsg: true
      }
      // if (!this.map.inputCityName) {
      //   return cb([])
      // }

      if (!this.map.keyWord) {
        this.$message({
          type: 'warning',
          message: '请输入地址关键字！'
        });
        this.searchList = []
        return cb(this.searchList)
      }
      this.$refs.keywordRef.activated = true
      this.queryAddrByKeywordApi(params).then(res => {
        const poiset = (res || {}).poiset || []
        this.searchList = poiset.map(ele => {
          return {
            ...ele,
            value: ele.name
          }
        })
        cb(this.searchList)
        this.map.poiset = poiset
        this.addMarker(poiset);
        if (!this.searchList.length) {
          this.$message({
            type: 'warning',
            message: '地址不存在，请重试输入地址'
          });
        }
      })
    },
    onSearchAddr(querystring, cb) {
      if (!querystring) {
        this.searchList = []
        return cb(this.searchList)
      }

      if (this.map.markerTpl) {
        this.map.vectorLayer.removeLayer(this.map.markerTpl);
      }
      if (this.map.keyWord.indexOf('市') > -1) {
        this.map.inputCityName = this.map.keyWord.split('市')[0]
      } else {
        this.map.inputCityName = ''
      }
      this.queryTipByKeyword(cb);
      this.removeMarkersList();
    },
    onAddrconfirm() {
      if (this.map.keyWord && this.searchList && this.searchList.length === 1) {
        this.onhandleCommand(this.searchList[0])
      }

      if (!this.map.keyWord || !this.map.coordinate) {
        this.$message({
          type: 'warning',
          message: '请输入关键字搜索，再选取地址！'
        });
        return;
      }

      this.map.currVo.addrDetail = this.map.addrDetail
      this.map.currVo.cityCode = this.map.cityCode
      this.map.currVo.cityName = this.map.cityName
      this.map.currVo.coordinate = this.map.coordinate

      this.map.currVo.province = this.map.province
      this.map.currVo.district = this.map.district

      this.mapVisible = false;
      this.adressIsNeedTip(this.map.currVo.addrDetail)
    },
    // 判断地址信息是否需要提示方法
    adressIsNeedTip(val) {
      let str = val;
      for(let j=0,len=this.sensitiveAdressList.length; j<len; j++) {
        if(str.includes(this.sensitiveAdressList[j])) {
          this.$alert('地址信息与顺丰网点冲突，请核实后下单', {
            title: '提示',
            confirmButtonText: '我知道了'
          })
          break;
        }
      }
    },
    inputFilterAddresss(val) {
      this.addressList = this.addressList
    },
    onSelectAddr(data, form) {
      form.addrDetail = data.address
      form.cityCode = data.cityCode
      form.cityName = data.cityName
      form.coordinate = data.coordinate
      form.orderPlacerName = data.contacts
      form.orderPlacerPhone = data.phone
      this.adressIsNeedTip(data.address)
    },
    onSelectRecAddr(data, form) {
      form.receiptAddress = data.address
      form.receiptName = data.contacts
      form.receiptPhone = data.phone
    },

    downLoadTpl(tplName) {
      let preUrl = getMvcUrl() + '/saas/orderCore/downLoadTpl?tplName=' + tplName;
      window.open(preUrl);
    },
    handleUsualLineJump_buildPassInfo(srcObj, targetObj) {
      targetObj.addrDetail = srcObj.addrDetail;
      targetObj.cityCode = srcObj.cityCode;
      targetObj.cityName = srcObj.cityName;
      targetObj.coordinate = srcObj.coordinate;
      if (srcObj.jobType) {
        targetObj.jobType = srcObj.jobType;
      }
      if (srcObj.orderPlacerName) {
        targetObj.orderPlacerName = srcObj.orderPlacerName;
      }
      if (srcObj.orderPlacerPhone) {
        targetObj.orderPlacerPhone = srcObj.orderPlacerPhone;
      }
      targetObj.sortNum = srcObj.sortNum;
    },
    //处理常用线路通过再来一单的操作
    handleUsualLineJump() {
      let that = this;
      let paramKey = 'usualLineToShipmentsParams';
      let shipmentsObj = window.sessionStorage.getItem(paramKey);
      window.sessionStorage.removeItem(paramKey);
      if (shipmentsObj) {
        let shipmentsObjs = JSON.parse(shipmentsObj);
        this.activeName = 'single';
        this.handleUsualLineJump_buildPassInfo(shipmentsObjs.start, this.form.start);
        this.handleUsualLineJump_buildPassInfo(shipmentsObjs.end, this.form.end);
        if (shipmentsObjs.stops && shipmentsObjs.stops.length > 0) {
          for (let i = 0; i < shipmentsObjs.stops.length; i++) {
            this.onAddStop();
            this.handleUsualLineJump_buildPassInfo(shipmentsObjs.stops[i], this.form.stops[i]);
          }
        }
        this.form.dataOwner = shipmentsObjs.dataOwner;
        this.form.cargoInfo = shipmentsObjs.cargoType;
        this.form.cargoVolume = shipmentsObjs.cargoVolume;
        this.form.cargoWeight = shipmentsObjs.cargoWeight;
        this.form.comment = shipmentsObjs.comment;
        this.form.totalLineDistance = shipmentsObjs.lineDistance;
        if (shipmentsObjs.needReceipt == 1) {
          //不需要回单
          this.form.needReceipt = 2;
        }
        else if (shipmentsObjs.needReceipt == 2) {
          //需要电子回单
          this.form.needReceipt = 1;
        } else if (shipmentsObjs.needReceipt == 3) {
          //电子+纸质回单
          this.form.needReceipt = 3;
          this.form.receiptAddress = shipmentsObjs.receiptAddress;
          this.form.receiptName = shipmentsObjs.receiptName;
          this.form.receiptPhone = shipmentsObjs.receiptPhone;
        }
        this.form.expectedPrice = shipmentsObjs.expectedPrice * 1;
        for (let i = 0; i < this.prev.vehicle.typeMapLens.length; i++) {
          if (this.prev.vehicle.typeMapLens[i].plVehicleCode === shipmentsObjs.vehicleType) {
            this.prev.vehicle.vehicleType = this.prev.vehicle.typeMapLens[i].plVehicleType;
            window.setTimeout(function () { that.prev.vehicle.vehicleLength = shipmentsObjs.vehicleLength; }, 3000);
            break;
          }
        }
      }
    },
    handleWaitHandleOrderJump() {
      let fields = ['cargoInfo', 'cargoVolume', 'cargoWeight', 'quantity', 'outerOrderId', 'totalLineDistance', 'comment'];
      let that = this;
      let paramKey = 'waitHandleOrderParams';
      let shipmentsObj = window.sessionStorage.getItem(paramKey);
      window.sessionStorage.removeItem(paramKey);
      if (shipmentsObj) {
        this.invokeSource = 'waitHandelOrder';
        this.thirdPlaceOrder = true;
        this.stopsDisabledSwitch = true;
        this.readOnly.hideAddStopBtn = true;
        let shipmentsObjs = JSON.parse(shipmentsObj);
        this.activeName = 'single';
        this.waitHandelOrderId = shipmentsObjs.id;
        this.systemCode = shipmentsObjs.systemCode;

        if (shipmentsObjs.needReceipt == 1) {
          //不需要回单
          this.form.needReceipt = 2;
        }
        else if (shipmentsObjs.needReceipt == 2) {
          //需要电子回单
          this.form.needReceipt = 1;
        } else if (shipmentsObjs.needReceipt == 3) {
          //电子+纸质回单
          this.form.needReceipt = 3;
          this.form.receiptAddress = shipmentsObjs.receiptAddress;
          if (shipmentsObjs.receiptAddress) {
            this.readOnly.receiptAddress = true;
          }
          this.form.receiptName = shipmentsObjs.receiptName;
          if (shipmentsObjs.receiptName) {
            this.readOnly.receiptName = true;
          }
          this.form.receiptPhone = shipmentsObjs.receiptPhone;
          if (shipmentsObjs.receiptPhone) {
            this.readOnly.receiptPhone = true;
          }
        }

        if (shipmentsObjs.needReceipt) {
          this.readOnly.needReceipt = true;
        }

        if (shipmentsObjs.start) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.start, this.form.start);
          if (this.form.start.addrDetail) {
            this.readOnly.startAddrDetail = true;
          }
          if (shipmentsObjs.start.orderPlacerName) {
            this.readOnly.startOrderPlacerName = true;
          }
          if (shipmentsObjs.start.orderPlacerPhone) {
            this.readOnly.startOrderPlacerPhone = true;
          }
          this.form.start.planArriveTm = shipmentsObjs.start.planArriveTm;
          if (shipmentsObjs.start.planArriveTm) {
            this.readOnly.startPlanArriveTm = true;
          }
          this.form.start.planSendtm = shipmentsObjs.start.planSendtm;
          if (shipmentsObjs.start.planSendtm) {
            this.readOnly.startPlanSendtm = true;
          }
        }
        if (shipmentsObjs.end) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.end, this.form.end);
          if (this.form.end.addrDetail) {
            this.readOnly.endAddrDetail = true;
          }
          if (shipmentsObjs.end.orderPlacerName) {
            this.readOnly.endOrderPlacerName = true;
          }
          if (shipmentsObjs.end.orderPlacerPhone) {
            this.readOnly.endOrderPlacerPhone = true;
          }
          this.form.end.planArriveTm = shipmentsObjs.end.planArriveTm;
          if (shipmentsObjs.end.planArriveTm) {
            this.readOnly.endPlanArriveTm = true;
          }
        }
        if (shipmentsObjs.stops && shipmentsObjs.stops.length > 0) {
          for (let i = 0; i < shipmentsObjs.stops.length; i++) {
            this.onAddStop();
            this.stopsReadOnly.push(JSON.parse(JSON.stringify(stopReadOnly)));

            this.handleUsualLineJump_buildPassInfo(shipmentsObjs.stops[i], this.form.stops[i]);
            if (shipmentsObjs.stops[i].addrDetail) {
              this.stopsReadOnly[i].addrDetail = true;
            }
            if (shipmentsObjs.stops[i].planArriveTm) {
              this.form.stops[i].planArriveTm = shipmentsObjs.stops[i].planArriveTm;
              this.stopsReadOnly[i].planArriveTm = true;
            }
            if (shipmentsObjs.stops[i].planSendtm) {
              this.form.stops[i].planSendtm = shipmentsObjs.stops[i].planSendtm;
              this.stopsReadOnly[i].planSendtm = true;
            }
            if (shipmentsObjs.stops[i].jobType) {
              this.form.stops[i].jobType = shipmentsObjs.stops[i].jobType;
              this.stopsReadOnly[i].jobType = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerPhone) {
              this.form.stops[i].orderPlacerPhone = shipmentsObjs.stops[i].orderPlacerPhone;
              this.stopsReadOnly[i].orderPlacerPhone = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerName) {
              this.form.stops[i].orderPlacerName = shipmentsObjs.stops[i].orderPlacerName;
              this.stopsReadOnly[i].orderPlacerName = true;
            }

          }
        }
        for (let i = 0; i < this.prev.vehicle.typeMapLens.length; i++) {
          if (this.prev.vehicle.typeMapLens[i].plVehicleCode === shipmentsObjs.vehicleType) {
            this.prev.vehicle.vehicleType = this.prev.vehicle.typeMapLens[i].plVehicleType;
            if (shipmentsObjs.vehicleType) {
              this.readOnly.vehicleType = true;
            }
            window.setTimeout(function () {
              that.prev.vehicle.vehicleLength = shipmentsObjs.vehicleLength;
              if (shipmentsObjs.vehicleLength) {
                that.readOnly.vehicleLength = true;
              }
            }, 3000);
            break;
          }
        }

        for (let i = 0; i < fields.length; i++) {
          if (fields[i] === 'quantity') {
            if (shipmentsObjs[fields[i]] && shipmentsObjs[fields[i]] >= 0) {
              this.form[fields[i]] = shipmentsObjs[fields[i]];
            }
          } else {
            this.form[fields[i]] = shipmentsObjs[fields[i]];
          }
          if (shipmentsObjs[fields[i]]) {
            this.readOnly[fields[i]] = true;
          }
        }

        if (shipmentsObjs.expectedPrice) {
          this.form.expectedPrice = shipmentsObjs.expectedPrice;
          window.setTimeout(function () { that.calcPrice(); }, 1000);
        }

        if (this.systemCode === "SF-SX") {
          this.readOnly.fromApi = true;
        }

        this.is_shunxin_order = true;
        this.calcDisAndTm();
      }
    },
    handleStopHandleOrderJump() {
      this.stopNoDisAndTm = true;
      let fields = ['cargoInfo', 'cargoVolume', 'cargoWeight', 'quantity', 'outerOrderId', 'totalLineDistance', 'comment'];
      let that = this;
      let paramKey = 'stopHandleOrderParams';
      let shipmentsObj = window.sessionStorage.getItem(paramKey);
      window.sessionStorage.removeItem(paramKey);
      if (shipmentsObj) {
        this.invokeSource = 'stopHandelOrder';
        // this.thirdPlaceOrder = true;
        // this.stopsDisabledSwitch = true;
        // this.readOnly.hideAddStopBtn = true;
        let shipmentsObjs = JSON.parse(shipmentsObj);
        this.stopOrderManageId = shipmentsObjs.orderManageId;
        this.stopOrderId = shipmentsObjs.orderId;
        this.activeName = 'single';
        this.form.dataOwner = shipmentsObjs.dataOwner;

        if (shipmentsObjs.needReceipt == 1) {
          //不需要回单
          this.form.needReceipt = 2;
        }
        else if (shipmentsObjs.needReceipt == 2) {
          //需要电子回单
          this.form.needReceipt = 1;
        } else if (shipmentsObjs.needReceipt == 3) {
          //电子+纸质回单
          this.form.needReceipt = 3;
          this.form.receiptAddress = shipmentsObjs.receiptAddress;
          if (shipmentsObjs.receiptAddress) {
            // this.readOnly.receiptAddress = true;
          }
          this.form.receiptName = shipmentsObjs.receiptName;
          if (shipmentsObjs.receiptName) {
            // this.readOnly.receiptName = true;
          }
          this.form.receiptPhone = shipmentsObjs.receiptPhone;
          if (shipmentsObjs.receiptPhone) {
            // this.readOnly.receiptPhone = true;
          }
        }

        if (shipmentsObjs.needReceipt) {
          // this.readOnly.needReceipt = true;
        }

        if (shipmentsObjs.start) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.start, this.form.start);
          if (this.form.start.addrDetail) {
            // this.readOnly.startAddrDetail = true;
          }
          if (shipmentsObjs.start.orderPlacerName) {
            // this.readOnly.startOrderPlacerName = true;
          }
          if (shipmentsObjs.start.orderPlacerPhone) {
            // this.readOnly.startOrderPlacerPhone = true;
          }
          this.form.start.planArriveTm = shipmentsObjs.start.planArriveTm;
          if (shipmentsObjs.start.planArriveTm) {
            // this.readOnly.startPlanArriveTm = true;
          }
          this.form.start.planSendtm = shipmentsObjs.start.planSendtm;
          if (shipmentsObjs.start.planSendtm) {
            // this.readOnly.startPlanSendtm = true;
          }
        }
        if (shipmentsObjs.end) {
          this.handleUsualLineJump_buildPassInfo(shipmentsObjs.end, this.form.end);
          if (this.form.end.addrDetail) {
            // this.readOnly.endAddrDetail = true;
          }
          if (shipmentsObjs.end.orderPlacerName) {
            // this.readOnly.endOrderPlacerName = true;
          }
          if (shipmentsObjs.end.orderPlacerPhone) {
            // this.readOnly.endOrderPlacerPhone = true;
          }
          this.form.end.planArriveTm = shipmentsObjs.end.planArriveTm;
          if (shipmentsObjs.end.planArriveTm) {
            // this.readOnly.endPlanArriveTm = true;
          }
        }
        if (shipmentsObjs.stops && shipmentsObjs.stops.length > 0) {
          for (let i = 0; i < shipmentsObjs.stops.length; i++) {
            this.onAddStop();
            // this.stopsReadOnly.push(JSON.parse(JSON.stringify(stopReadOnly)));

            this.handleUsualLineJump_buildPassInfo(shipmentsObjs.stops[i], this.form.stops[i]);
            if (shipmentsObjs.stops[i].addrDetail) {
              // this.stopsReadOnly[i].addrDetail = true;
            }
            if (shipmentsObjs.stops[i].planArriveTm) {
              this.form.stops[i].planArriveTm = shipmentsObjs.stops[i].planArriveTm;
              // this.stopsReadOnly[i].planArriveTm = true;
            }
            if (shipmentsObjs.stops[i].planSendtm) {
              this.form.stops[i].planSendtm = shipmentsObjs.stops[i].planSendtm;
              // this.stopsReadOnly[i].planSendtm = true;
            }
            if (shipmentsObjs.stops[i].jobType) {
              this.form.stops[i].jobType = shipmentsObjs.stops[i].jobType;
              // this.stopsReadOnly[i].jobType = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerPhone) {
              this.form.stops[i].orderPlacerPhone = shipmentsObjs.stops[i].orderPlacerPhone;
              // this.stopsReadOnly[i].orderPlacerPhone = true;
            }

            if (shipmentsObjs.stops[i].orderPlacerName) {
              this.form.stops[i].orderPlacerName = shipmentsObjs.stops[i].orderPlacerName;
              // this.stopsReadOnly[i].orderPlacerName = true;
            }

          }
        }
        for (let i = 0; i < this.prev.vehicle.typeMapLens.length; i++) {
          if (this.prev.vehicle.typeMapLens[i].plVehicleCode === shipmentsObjs.vehicleType) {
            this.prev.vehicle.vehicleType = this.prev.vehicle.typeMapLens[i].plVehicleType;
            if (shipmentsObjs.vehicleType) {
              // this.readOnly.vehicleType = true;
            }
            window.setTimeout(function () {
              that.prev.vehicle.vehicleLength = shipmentsObjs.vehicleLength;
              if (shipmentsObjs.vehicleLength) {
                // that.readOnly.vehicleLength = true;
              }
            }, 3000);
            break;
          }
        }

        for (let i = 0; i < fields.length; i++) {
          if (fields[i] === 'quantity') {
            if (shipmentsObjs[fields[i]] && shipmentsObjs[fields[i]] >= 0) {
              this.form[fields[i]] = shipmentsObjs[fields[i]];
            }
          } else {
            this.form[fields[i]] = shipmentsObjs[fields[i]];
          }
          if (shipmentsObjs[fields[i]]) {
            // this.readOnly[fields[i]] = true;
          }
        }

        if (shipmentsObjs.expectedPrice) {
          this.form.expectedPrice = shipmentsObjs.expectedPrice;
          window.setTimeout(function () { that.calcPrice(); }, 1000);
        }
        // this.calcDisAndTm();
      }
    },
    getFileByCode(fileCode) {
      let carImage = '';
      try {
        carImage = require('@/assets/car' + fileCode + '.png')
      } catch(e){
        carImage = require('@/assets/car-default.png')
      }
      return carImage
    },
    // 检查并调用查询司机信息接口
    checkAndQueryDriverInfo() {
      // 只有在司机、车辆和计划发车时间都填写后才调用接口
      if (this.form.assignDriverParam.userId && 
          this.form.assignDriverParam.vehicleSerial && 
          this.form.start.planSendtm) {
        const params = {
          resourceId: this.form.assignDriverParam.userId,
          vehicleCode: this.form.assignDriverParam.vehicleSerial,
          planDepartTm: this.form.start.planSendtm
        }
        this.driverInfoLoading = true;
        this.disablePlaceOrder = false; 
        this.queryDriverInfo(params).then(res => {
          if (res && res?.remarks) {
            this.driverInfoRemarks = res.remarks
          } else {
            this.driverInfoRemarks = ''
          }
          this.disablePlaceOrder = false;
        }).catch(e => {
          this.driverInfoRemarks = ''
          this.disablePlaceOrder = true
        }).finally(() => {
          this.driverInfoLoading = false;
        })
      } else {
        // 清空备注
        this.driverInfoRemarks = ''
        this.driverInfoLoading = false;
        this.disablePlaceOrder = false;
      }
    }
  }

};
